// client/src/components/Admin/Dashboard/_shared/ChartCard.js
//
// M06 Fase 4 - Wrapper estandar para una grafica. Cabecera con titulo,
// subtitulo y selector opcional. Cuerpo libre.

import React from "react";
import styles from "./ChartCard.module.scss";

export function ChartCard({ title, subtitle, actions, children }) {
  return (
    <div className={styles.chartCard}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          {title ? <div className={styles.title}>{title}</div> : null}
          {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
